// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m086","name":"styles_name__2cBCP","phone":"styles_phone__33jnb"};